/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Auth_Provider_Coming_SoonInputs */



/**
* | output |
* | --- |
* | "{provider} login coming soon!" |
*
* @param {Auth_Provider_Coming_SoonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_provider_coming_soon = /** @type {((inputs: Auth_Provider_Coming_SoonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Provider_Coming_SoonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.provider}-Anmeldung kommt bald!`)
	return /** @type {LocalizedString} */ (`${i?.provider} login coming soon!`)
});